var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Regular",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.937,23.962c-1.216,0-2.426-0.187-3.596-0.554c-3.058-0.96-5.559-3.054-7.042-5.896   c-1.483-2.842-1.771-6.091-0.811-9.149c0.961-3.058,3.054-5.559,5.896-7.042c1.714-0.895,3.63-1.368,5.539-1.368   c1.218,0,2.433,0.187,3.609,0.557c0.314,0.099,0.525,0.386,0.525,0.715c0,0.329-0.211,0.617-0.525,0.716   c-4.396,1.383-7.35,5.409-7.351,10.018c0.001,4.608,2.955,8.634,7.351,10.017c0.314,0.099,0.525,0.386,0.525,0.715   s-0.211,0.617-0.525,0.715C18.363,23.775,17.153,23.962,15.937,23.962z M15.924,1.454c-1.67,0-3.345,0.414-4.846,1.197   C8.592,3.949,6.76,6.137,5.92,8.813c-0.841,2.676-0.589,5.519,0.709,8.005s3.486,4.318,6.162,5.159   c1.025,0.322,2.084,0.485,3.147,0.485c0.289,0,0.578-0.012,0.866-0.036c-3.754-2.101-6.121-6.087-6.122-10.466   c0.001-4.381,2.369-8.367,6.124-10.468C16.513,1.466,16.218,1.454,15.924,1.454z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default ForwardRef;